
import { Button } from '@/components/core/Button';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogHeaderDefault,
} from '@/components/core/Dialog';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';
import { logger } from '@/services/logger';

import { useDeleteBulkSubscription } from '../bulk-subscriptions.queries';
import { BulkSubscription } from '../bulk-subscriptions.types';

const DeleteConfirmationDialog = ({
    entities,
    open,
    onClose,
}: {
    entities: BulkSubscription[],
    open: boolean;
    onClose: (shouldRefetchData?: boolean) => void;
}) => {

    const { toast } = useToast();
    const { t } = useTranslation();

    const { mutate: deleteBulkSubscription, isPending: isDeletePending } = useDeleteBulkSubscription({
        onSuccess: () => {
            toast.success('BULK_SUBSCRIPTION.DELETED_SUCCESSFULLY');
            onClose(true);
        },
        onError: (error) => {
            logger.error('DeleteConfirmationDialog: ', error);
            toast.error('ERROR_OCCURRED');
        }
    });

    const deleteEntities = () => {
        // FIXME: Have one endpoint to delete multiple entities
        entities.forEach(entity => deleteBulkSubscription(entity.id));
    };

    return (
        <Dialog open={open} onOpenChange={() => onClose()}>
            <DialogContent
                variant="small"
                onPointerDownOutside={() => onClose()}
                onInteractOutside={() => onClose()}
            >
                <DialogHeader>
                    <DialogHeaderDefault>
                        {t('CONFIRM_DELETE')}
                    </DialogHeaderDefault>
                </DialogHeader>

                <DialogBody padding="none" className="tw-p-4">
                    <div>{t('BULK_SUBSCRIPTION.DELETE_CONFIRMATION')}</div>

                    <ul className="tw-pt-2">
                        {entities.map(entity => <li key={entity.id}>{entity.name}</li>)}
                    </ul>
                </DialogBody>
                <DialogFooter>
                    <Button
                        type="button"
                        variant="destructive"
                        disabled={isDeletePending}
                        loading={isDeletePending}
                        onClick={deleteEntities}
                    >
                        {t('ACTION.DELETE')}
                    </Button>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" onClick={() => onClose()} disabled={isDeletePending}>
                            {t('NO')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteConfirmationDialog };
